// ==========================================================================
// YEEZY CART - przyciski +/- do zmiany ilości, przeliczanie na bieżąco
// (Shopify AJAX Cart API - /cart/change.js), bez klikalnego pola liczbowego.
// ==========================================================================
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('.yeezy-cart');
    if (!section) return;

    section.addEventListener('click', function (event) {
      var decreaseBtn = event.target.closest('[data-yeezy-cart-decrease]');
      var increaseBtn = event.target.closest('[data-yeezy-cart-increase]');
      if (!decreaseBtn && !increaseBtn) return;

      var itemRow = event.target.closest('[data-yeezy-cart-item]');
      if (!itemRow) return;

      var key = itemRow.getAttribute('data-key');
      var qtyEl = itemRow.querySelector('[data-yeezy-cart-qty]');
      var currentQty = parseInt(qtyEl.textContent, 10) || 0;
      var newQty = increaseBtn ? currentQty + 1 : currentQty - 1;
      if (newQty < 0) newQty = 0;

      var btn = decreaseBtn || increaseBtn;
      btn.disabled = true;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          if (newQty === 0) {
            var divider = itemRow.nextElementSibling;
            if (divider) divider.remove();
            itemRow.remove();

            if (cart.item_count === 0) {
              window.location.reload();
              return;
            }
          } else {
            var updatedItem = null;
            for (var i = 0; i < cart.items.length; i++) {
              if (cart.items[i].key === key) {
                updatedItem = cart.items[i];
                break;
              }
            }
            if (updatedItem) {
              qtyEl.textContent = updatedItem.quantity;
              var priceEl = itemRow.querySelector('[data-yeezy-cart-line-price]');
              if (priceEl) priceEl.textContent = formatMoney(updatedItem.final_line_price);
            }
            btn.disabled = false;
          }

          var totalEl = document.querySelector('[data-yeezy-cart-total]');
          if (totalEl) {
            totalEl.innerHTML = formatMoney(cart.total_price) + '<span class="yeezy-cart__cursor">_</span>';
          }

          var titleCountEl = document.querySelector('[data-yeezy-cart-title-count]');
          if (titleCountEl) titleCountEl.textContent = cart.item_count;

          var headerCountEl = document.querySelector('[data-yeezy-cart-count]');
          if (headerCountEl) headerCountEl.textContent = cart.item_count;
        })
        .catch(function () {
          btn.disabled = false;
        });
    });

    // Formatowanie ceny zgodnie z ustawieniem waluty sklepu (shop.money_format),
    // żeby ceny doliczane przez AJAX wyglądały tak samo jak te z Liquid.
    function formatMoney(cents) {
      var format = window.yeezyMoneyFormat || '${{amount}}';
      var placeholderMatch = format.match(/\{\{\s*(\w+)\s*\}\}/);
      var key = placeholderMatch ? placeholderMatch[1] : 'amount';

      var withComma = key.indexOf('comma_separator') !== -1;
      var noDecimals = key.indexOf('no_decimals') !== -1;

      var value = (cents / 100).toFixed(noDecimals ? 0 : 2);
      var parts = value.split('.');
      var thousandsSep = withComma ? '.' : ',';
      var decimalSep = withComma ? ',' : '.';

      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
      var formatted = parts.length > 1 ? parts[0] + decimalSep + parts[1] : parts[0];

      return format.replace(/\{\{\s*\w+\s*\}\}/, formatted);
    }
  });
})();
